// extracted by mini-css-extract-plugin
export default {"o-paragraph":"Paragraph_o-paragraph__Tl8or","o-paragraph--small":"Paragraph_o-paragraph--small__iitQc"};